module.exports = __webpack_public_path__ + "static/media/shopify-logo.4902fe23.svg";